module.exports = __webpack_public_path__ + "img/cloud-download-fill.54c03b2b.svg";